<template>
  <iframe
    v-if="storeFeatureLoadable"
    :src="`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`"
    frameborder="0"
    allowfullscreen
  ></iframe>
</template>
<script>
import featureMixin from "../mixins/featureMixin";

export default {
  name: "YoutubeIframe",
  mixins: [featureMixin],
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
};
</script>
